import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { Helpers } from "../helpers";
import { ScriptLoaderService } from "../_services/script-loader.service";
import { appService } from "../_services/app.service";
import { CommonService } from "../_services/common.service";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../environments/environment";
import { RequestOptions, Headers, Http } from "@angular/http";
import { whenIdle } from "@amcharts/amcharts4/core";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import * as jsPDF from "jsPDF";
import html2canvas from "html2canvas";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { DecryptPipe } from "../auth/_services/encrypt-decrypt.pipe";
const LNG_KEY = "SELECTED_LANGUAGE";

declare var $: any;

@Component({
  selector: "app-documents",
  templateUrl: "./documents.component.html",
})
export class DocumentsComponent implements OnInit, AfterViewInit {
  selectedLang: string;
  DocumentType: any = "Documents";
  TransactionList: any = [];
  datatable: any;
  DocumentTransaction: any;
  IsSearchHidden: any = false;
  FileStructure: any = [];
  static documentsComponent: DocumentsComponent;
  selectFile: any;
  // TransactionId: any;
  ParentId: any = null;
  // From: any = 'Document';

  //add kevin 27/10/2020
  isTransporter: boolean = false;
  isCustomer: boolean = false;
  UserId: any;
  //end

  //KSH merge pdf/images
  @ViewChild("content") content: ElementRef;
  SearchDocument: any = {};
  SearchResponse: any;
  file_url: SafeResourceUrl;
  //end
  hostURL: any = environment.apiUrl;
  dataArray: any[] = [];
  SubReferenceId: any = null;
  UploadPODOrderWise: boolean = true;
  @Output() OnSaveClick = new EventEmitter<any>();
  @Input() ReferenceId: any
  @Input() UseDirectReferenceId: boolean=false;

  constructor(
    private _script: ScriptLoaderService,
    private _appService: appService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private cookieService: CookieService,
    private anghttp: Http,
    private service: TranslateConfigService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    private decryptpipe: DecryptPipe
  ) {
    DocumentsComponent.documentsComponent = this;

    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    //add kevin 27/10/2020
    this.isTransporter = JSON.parse(localStorage.getItem("isTransporter"));
    this.isCustomer = JSON.parse(localStorage.getItem("isCustomer"));
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    //end
    this.LoadUploadPODOrderWise();
    var obj: any = {};
    obj.ParentId = null;
    obj.FileName = "Modules";
    this.FileStructure.push(obj);
    this.ParentId = null;
    // this.GetDocumentsList();
  }

  ngAfterViewInit() {
    // 
    $("#DocumentFrom").val("Document");
    this.CreateDefaultFolders();
    if (this.DocumentTransaction !== null) {
      this.GetDocumentsList();
    }
    // this.getAttachmentList(ReferenceId);
  }

  LoadUploadPODOrderWise() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "UploadPODOrderWise")
      .subscribe(
        (response) => {
          if (response == "1") {
            this.UploadPODOrderWise = true;
          } else {
            this.UploadPODOrderWise = false;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching data !",
            "error"
          );
        }
      );
  }

  CreateDefaultFolders() {
    this._appService.Get("Document", "CreateDefaultFolders").subscribe(
      (response) => { },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  GetDocumentsList() {
    if (this.datatable) {
      this.datatable.destroy(); // Destroy previous instance
    }
    // 
    this.datatable = (<any>$("#m_datatable_Document")).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Document/GetDocumentList",
            params: {
              // custom parameters
              ReferenceId:
                DocumentsComponent.documentsComponent.DocumentTransaction,
              From: $("#DocumentFrom").val(),
              //add kevin 27/10/2020
              isTransporter:
                DocumentsComponent.documentsComponent.isTransporter,
              isCustomer: DocumentsComponent.documentsComponent.isCustomer,
              userId: DocumentsComponent.documentsComponent.UserId,
              //end
              SubReferenceId:
                DocumentsComponent.documentsComponent.SubReferenceId,
              DocumentType: DocumentsComponent.documentsComponent.DocumentType,
              UseDirectReferenceId: DocumentsComponent.documentsComponent.UseDirectReferenceId
            },
            headers: {
              "Authorization": DocumentsComponent.documentsComponent._appService.getAuthToken(),
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onChange: true,
        input: $("#FileFolderSearch"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          //Start: Download Button
          $(row)
            .find(".btnDownload")
            .click(function () {
              var path = $(this).attr("Id");
              var FileName = $(this).attr("FileName");
              var path1 =
                environment.apiUrl + path + FileName + "." + data.FileExtension;
              window.open(path1, "");
            });
          $(row)
            .find(".btnFolderDownload")
            .click(function () {
              DocumentsComponent.documentsComponent.DownloadFolder(data.Id);
            }); //Ends;

          //Start: Delete Button
          $(row)
            .find(".btnDelete")
            .click(function () {
              var Id = $(this).attr("Id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  DocumentsComponent.documentsComponent._appService
                    .Delete("Document", "DeleteAttachment", Id)
                    .subscribe(
                      (response) => {
                        DocumentsComponent.documentsComponent.datatable.reload();
                        DocumentsComponent.documentsComponent.toastr.success(
                          "Deleted Succesfully",
                          "Success"
                        );
                      },
                      (err) => {
                        DocumentsComponent.documentsComponent.toastr.error(
                          "An error occured while deleting data !",
                          "error"
                        );
                      }
                    );
                }
              }); //Ends;
            });
          $(row)
            .find(".btnGoInsideFolder")
            .click(function () {
              var Id = $(this).attr("Id");
              if (Id) {
                DocumentsComponent.documentsComponent.GoToChild(data);
                DocumentsComponent.documentsComponent.datatable.search(
                  Id,
                  "ParentId"
                );
              }
            });
        },
      },
      columns: [
        {
          field: "Id",
          title: "#",
          sortable: !1,
          width: 20,
          selector: {
            class:
              "m-checkbox m-datatable--on-check m-checkbox--solid m-checkbox--brand BookingIdCheckbox",
          },
          template: function (t) {
            let value = t;
            return value;
          },
        },
        {
          field: "FileName",
          title: this.selectedLang == "sp" ? "Nombre de archivo" : "File Name",
          filterable: !1,
          width: 500,
          template: function (t) {
            var btn = "";
            if (t.FileExtension != "Folder") {
              var FileName = t.FileName.split(/_(.+)/)[1];
              if (FileName == undefined) FileName = t.FileName;
              if (t.FileExtension == "apk") {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/APK.png" style="width: 20px;"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (t.FileExtension == "csv") {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/CSV.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (
                t.FileExtension == "doc" ||
                t.FileExtension == "docx"
              ) {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/DOC.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (t.FileExtension == "exe") {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/EXE.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (
                t.FileExtension == "jpg" ||
                t.FileExtension == "jpeg"
              ) {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/JPEG.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (t.FileExtension == "pdf") {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/PDF.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (t.FileExtension == "png") {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/PNG.png" class="ImgFileType"></img>  ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (
                t.FileExtension == "ppt" ||
                t.FileExtension == "pptx"
              ) {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/PPT.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (t.FileExtension == "psd") {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/PSD.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (t.FileExtension == "sql") {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/SQL.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (t.FileExtension == "txt") {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/TXT.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else if (
                t.FileExtension == "xls" ||
                t.FileExtension == "xlsx"
              ) {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/XLS.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              } else {
                // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
                btn = `<a target="_blank" rel="noopener noreferrer" href="${environment.apiUrl +
                  t.Path +
                  t.FileName +
                  "." +
                  t.FileExtension
                  } "  title="View File"> 
                                <img src="./assets/app/media/img/logos/FileImages/Default.png" class="ImgFileType"></img> ${FileName}.${t.FileExtension
                  }
                                </a>`;
              }
            } else {
              if (t.FileExtension == "Folder") {
                // btn = `<span  Id="${t.Id}"   class="btnGoInsideFolder  btn" style="color: #3b67fb;padding: 0px"><img src="./assets/app/media/img/logos/FileImages/folder.png" style="height: 30px;width: 35px;"></img>  ${t.FileName}</span>`
                btn = `<div style="display:flex;"  Id="${t.Id}"   class="btnGoInsideFolder  btn" style="color: #3b67fb;padding: 0px"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" viewBox="0 0 24 24" version="1.1"  class="kt-svg-icon">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z" fill="#000000" opacity="0.3"/>
                                </g>
                            </svg><span style="transform:translateY(10px) ; margin-left:10px">${t.FileName}</span></div>`;
              }
            }
            return btn;
          },
        },
        {
          field: "DocumentType",
          title:
            this.selectedLang == "sp" ? "Tipo de documento" : "Document Type",
          filterable: !1,
          width: 130,
        },
        {
          field: "ModifiedDate",
          title:
            this.selectedLang == "sp"
              ? "Fecha de modificación"
              : "Modified Date",
          filterable: !1,
          width: 100,
        },
        {
          field: "UploadedBy",
          title: this.selectedLang == "sp" ? "Subido por" : "Uploaded By",
          filterable: !1,
          width: 120,
        },
        {
          field: "Actions",
          width: 80,
          title: this.selectedLang == "sp" ? "Acciones" : "Actions",
          sortable: !1,
          overflow: "visible",
          template: function (t) {
            var btn = "";
            const bookLiveTrack =
              DocumentsComponent.documentsComponent.translate.instant(
                "BYCUSTOMER.bookLiveTrack"
              );
            const tripDownloadOrder =
              DocumentsComponent.documentsComponent.translate.instant(
                "BYCUSTOMER.tripDownloadOrder"
              );
            const tripViewOrderDetail =
              DocumentsComponent.documentsComponent.translate.instant(
                "BYCUSTOMER.tripViewOrderDetail"
              );
            const tripViewRouteAndLoadPlan =
              DocumentsComponent.documentsComponent.translate.instant(
                "BYCUSTOMER.tripViewRouteAndLoadPlan"
              );
            btn += `<span style="overflow: visible; width: 110px;">
                        <a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown">
                        <i class="la la-ellipsis-h"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-left">`;
            if (
              DocumentsComponent.documentsComponent.commonService.CheckHasRight(
                "EDIT",
                "ATTACHMENT_DETAILS"
              )
            ) {
              if (t.FileExtension != "Folder") {
                btn += `<a id="${t.Path}" style="cursor:pointer" FileName="${t.FileName}"  class="btnDownload m-portlet__nav-link dropdown-item" title="Download"> 
                                        <i class="la la-download"></i> Download
                                        </a>`;
              } else {
                btn += `<a id="${t.Path}" style="cursor:pointer" FileName="${t.FileName}"  class="btnFolderDownload dropdown-item" title="Download"> 
                                        <i class="la la-download"></i> Download
                                        </a>`;
              }
            }
            if (
              DocumentsComponent.documentsComponent.commonService.CheckHasRight(
                "DELETE",
                "ATTACHMENT_DETAILS"
              )
            ) {
              btn += `<a Id="${t.Id}" style="cursor:pointer" class="btnDelete dropdown-item" title="Delete">
                                    <i class="la la-trash"></i> Delete
                                    </a>`;
            }

            btn += `</div>
                       </span>`;
            return btn;
          },
        },
      ],
    });
    // setTimeout(() => {
    //   const records = this.datatable.dataSet;
    //   console.log("Records data:", records);
    // }, 1000);
    // console.log("Data tbale data", this.datatable.data);
  }

  DownloadFolder(Id) {
    this._appService.GetById("Document", "DownloadFolder", Id).subscribe(
      (response) => {
        if (response != "" && response != undefined && response != null) {
          var path =
            environment.apiUrl + "/DocumentLibrary/Downloads/" + response;
          window.open(path, "");
        }
      },
      (err) => {
        this.toastr.error("Error occured while downaloading folder !", "error");
      }
    );
  }

  GoBackFolder(ParentId, index) {
    this.FileStructure.splice(index);
    this.datatable.search(ParentId, "ParentId");
    this.ParentId = ParentId;
  }

  GoToChild(data) {
    var flagExist = false;
    this.FileStructure.forEach((element) => {
      if (data.Id == element.ParentId) flagExist = true;
    });
    if (!flagExist) {
      var obj: any = {};
      obj.ParentId = data.Id;
      obj.FileName = data.FileName;
      this.FileStructure.push(obj);
      this.ParentId = data.Id;
    }
  }

  //-----------------------------------Upload Document-------------------------------------

  async UploadAttachment(event) {
    var fileArray: any = [];
    if (event.target.files.length <= 10) {
      for (let index = 0; index < event.target.files.length; index++) {
        var obj: any = {};
        obj = event.target.files[index];
        fileArray.push(obj);
      }
      for await (const element of fileArray) {
        this.selectFile = element;
        if (
          this.selectFile == undefined ||
          this.selectFile == "" ||
          this.selectFile == null
        ) {
          this.toastr.error("Please select file to upload", "error");
          $("#UploadDocFile").val("");
          return false;
        }

        //--------------File True Type Validation ---------- added by vithujan 22-09-2022
        var fileReader = new FileReader();
        var isValidFileType = true;
        fileReader.onloadend = function (e: any) {
          var arr = new Uint8Array(e.target.result).subarray(0, 4);
          var header = "";

          for (var i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
          }

          //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
          if (
            header.toUpperCase() != "89504E47" &&
            header.toUpperCase() != "FFD8FFE0" &&
            header.toUpperCase() != "FFD8FFE1" &&
            header.toUpperCase() != "25504446"
          ) {
            DocumentsComponent.documentsComponent.toastr.error(
              DocumentsComponent.documentsComponent.translate.instant(
                "SETTING.DocOnly"
              ),
              "Error"
            );
            $("#UploadDocFile").val("");
            isValidFileType = false;
            return false;
          }
        };
        fileReader.readAsArrayBuffer(this.selectFile);
        //----------------------------------------------

        await new Promise(async (resolve1, reject1) => {
          await setTimeout(async () => {
            if (isValidFileType) {
              //--------------Filename Validation ---------- added by vithujan 23-09-2022
              if (this.hostURL !== "https://pittie.ifreightbox.net/") {
                var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
                if (!format.test(this.selectFile.name)) {
                  this.toastr.error(
                    this.translate.instant("SETTING.InvalidFile"),
                    "Error"
                  );
                  $("#UploadDocFile").val("");
                  return false;
                }
              }
              //--------------File Type Validation ---------- added by vithujan 15-09-2022
              var meme_type = this.selectFile.type;
              if (
                meme_type.toLowerCase() != "image/jpeg" &&
                meme_type.toLowerCase() != "image/png" &&
                meme_type.toLowerCase() != "application/pdf"
              ) {
                this.toastr.error(
                  this.translate.instant("SETTING.DocOnly"),
                  "Error"
                );
                $("#UploadDocFile").val("");
                return false;
              }
              //end

              //--------------Size Validation----------------
              var bytesize = this.selectFile.size;
              var kbsize: any = 0;
              kbsize = (bytesize / 1000).toFixed(2);
              let IsFileSizeExceed = false;
              if (kbsize > 1024) {
                if (kbsize / 1024 > environment.maxFileSize)
                  IsFileSizeExceed = true;
                else IsFileSizeExceed = false;
              }
              if (IsFileSizeExceed) {
                this.toastr.error(
                  this.translate.instant("SETTING.FileSize"),
                  "Error"
                );
                $("#UploadDocFile").val("");
                return false;
              }
              //----------------------------------------------

              var fd = new FormData();
              if (fd.has("file")) {
                fd.set("file", this.selectFile);
              } else {
                fd.append("file", this.selectFile);
              }
              var headers = new Headers();
              let user_access_token = this.decryptpipe.transform(
                JSON.parse(this.cookieService.get("user_access_token"))
              );
              const token: string = "Bearer " + user_access_token;
              headers.append("Authorization", token);
              let options = new RequestOptions({ headers: headers });
              var apiUrl = '';

              if (this.UploadPODOrderWise == true && this.DocumentType == 'POD') {
                apiUrl = environment.apiUrl +
                  "/api/Document/UploadAttachmentV2?ReferenceId=" +
                  this.DocumentTransaction +
                  "&TransectionType=" +
                  this.DocumentType +
                  "&ParentId=" +
                  this.ParentId +
                  "&SubReferenceId=" +
                  this.SubReferenceId;
              } else {
                const transectionType = DocumentsComponent.documentsComponent.UseDirectReferenceId === true ? "Bookings" : this.DocumentType;

                apiUrl = environment.apiUrl +
                  "/api/Document/UploadAttachment?ReferenceId=" +
                  this.DocumentTransaction +
                  "&TransectionType=" +
                  transectionType +
                  "&ParentId=" +
                  this.ParentId;
              }

              const req1 = this.anghttp.post(apiUrl, fd, options).subscribe(
                async (response) => {
 
                  DocumentsComponent.documentsComponent.datatable.reload();
                  const updatesucess = await this.translate.instant(
                    "ALERTMESSAGES.updatesucess"
                  );
                  this.toastr.success(updatesucess, "Success");
                  $("#UploadDocFile").val("");
                  this.OnSaveClick.emit(true);
                  resolve1(updatesucess);
                },
                (err) => {
                  $("#UploadDocFile").val("");
                  this.toastr.error(
                    "Error occured while Uploading...",
                    "error"
                  );
                  reject1("Error occured while Uploading...");
                }
              );
            }
          }, 500);
        });
      }
    } else {
      this.toastr.error("Please select maximum 10 files at a time...", "error");
    }
  }

  // CreateNewFolder() {
  //     var data: any = [];
  //     data.FileName = "Dhwani";
  //     data.FileExtension = "Folder";
  //     data.ParentId = this.ParentId;
  //     this._appService.Post("Document", "CreateNewFolder", data).subscribe(response => {
  //     }, err => {
  //         this.toastr.error("Error occurred while saving data !", 'error');
  //     });
  // }

  //-------------------------Old Development-----------------------------------------------------------

  // RefreshDropDown() {
  //     setTimeout(function () {
  //         (<any>$("#SelectDocumentType")).selectpicker("refresh");
  //         (<any>$("#SelectTransactionType")).selectpicker("refresh");
  //     }, 500);
  // }

  // GetTransaction() {
  //     this._appService.GetListById("Document", "GetTransactionList", this.DocumentType).subscribe(response => {
  //         this.TransactionList = response;
  //         setTimeout(function () {
  //             (<any>$("#SelectTransactionType")).selectpicker("refresh");
  //         }, 100);
  //     }, err => {
  //         this.toastr.error(err._body.replace(/"/g, ""), "error");
  //     });
  // }

  // -----------------------------------Datatable------------------------------------------

  // ClearSearch() {
  //     this.DocumentType = '';
  //     this.DocumentTransaction = '';
  //     this.RefreshDropDown();
  //     DocumentsComponent.documentsComponent.datatable.search(this.DocumentTransaction, 'ReferenceId');

  // }

  // ValidatedateRequiredFeild() {
  //     var flag = true;

  //     if (!this.commonService.ValidateRequiredField2($("#SelectDocumentType"), $("#FieldSetModule"), 'Please Select Module', 'after', '')) {
  //         flag = false;
  //     }
  //     if (!this.commonService.ValidateRequiredField2($("#SelectTransactionType"), $("#FieldSetTransaction"), 'Please Select Module', 'after', '')) {
  //         flag = false;
  //     }

  //     return flag;
  // }

  // GetSelectData() {

  // }

  //KSH merge pdf/images
  // makePdf() {
  //
  //   var base64 = (document.getElementById("imageid"));
  //   let doc = new jsPDF();

  //   // this.file_url = this.sanitizer.bypassSecurityTrustResourceUrl('http://africau.edu/images/default/sample.pdf');

  //   // let imageData = document.getElementById('data' + i)
  //   // console.log(imageData);

  //   // doc.addImage(imageData, "JPG", 10, (i + 1) * 10, 180, 150);
  //   // doc.addPage();

  //   for (var i = 0; i < this.SearchResponse.length; i++) {
  //     // let imageData = this.getBase64Image(document.getElementById('data' + i));
  //     let imageData = document.getElementById('data' + i)
  //     console.log(imageData);

  //     doc.addImage(imageData, "JPG", 10, (i + 1) * 10, 180, 150);
  //     doc.addPage();
  //   }

  //   // doc.autoTable(col, rows);

  //   doc.save('FirstPdf.pdf');
  // }

  // getBase64Image(img) {
  //   var canvas = document.createElement("canvas");
  //   console.log("image");
  //   canvas.width = img.width;
  //   canvas.height = img.height;
  //   var ctx = canvas.getContext("2d");
  //   ctx.drawImage(img, 0, 0);
  //   var dataURL = canvas.toDataURL("image/png");
  //   return dataURL;
  // }
  //end

  DownloadSelectedFile() {
    var rows = this.datatable;
    rows.rows(".m-datatable__row--active");
    if (rows.nodes().length > 0) {
      Helpers.setLoading(true);
      var selectedListArray: any = [];
      $.each(rows.nodes(), function (i) {
        var keys = Object.keys(rows.nodes()[i]);
        var selectedListOBJ: any = {};
        selectedListOBJ = rows.nodes()[i][keys[0]].obj;
        selectedListArray.push(selectedListOBJ);
      });
      console.log("selectedListArray", selectedListArray);
      var isValidate: any = true;
      var selectedFilePathListArray: any = [];
      selectedListArray.forEach((element) => {
        var obj: any = {};
        obj.Id = element.Id;
        obj.FilePath =
          element.Path + element.FileName + "." + element.FileExtension;
        obj.FileExtension = element.FileExtension;
        selectedFilePathListArray.push(obj);
      });
      this._appService
        .Post("Document", "dc_DownloadSelectedFile", selectedFilePathListArray)
        .subscribe(
          (response) => {
            Helpers.setLoading(false);
            this.DownloadFile(response);
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
    } else {
      this.toastr.error("Please select any PDF file", "Alert");
    }
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(
      FileContent.Content,
      FileContent.ContentType
    );
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileSalesReport").attr("href", url);
    $("#DownLoadFileSalesReport").attr("download", FileContent.FileName);
    let element: HTMLElement = document.getElementById(
      "DownLoadFileSalesReport"
    ) as HTMLElement;
    element.attributes;
    element.click();
  }

  //added by vithujan 20-09-2022
  OnCloseModal() {
    $("#UploadInstructions123").modal("hide");
  }

  OnShowModal() {
    $(".UploadInstructions123").modal("show");
  }
  //end

  //added by rahul
  getAttachmentList(ReferenceId: any) {
    this._appService
      .GetByTwoId(
        "Document",
        "GetDocumentlsits",
        ReferenceId,
        DocumentsComponent.documentsComponent.UserId
      )
      .subscribe(
        (response) => {
          this.dataArray = response;
          console.log("res", response);
        },
        (err) => {
          var OwnershipError = this.translate.instant(
            "READYTODISPATCH.Erroroccurred"
          );
          this.toastr.error(OwnershipError, "error");
        }
      );
  }
  //end

}
